import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import {
  modelDirListAction,
  modelAddAction,
  resetMasterMessage,
  loadingMasterAction,
} from "../../redux/actions/master.action.js";
import { useDispatch, useSelector } from "react-redux";
import { Plus } from "lucide-react";

function ModalAdd() {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleShow = () => {
    dispatch(modelDirListAction());
    setShow(true);
  };

  const [name, setName] = useState("");
  const [modelName, setModelName] = useState("");
  const [errorMsg, setErrorMsg] = useState("")
  const [modelError, setModelError] = useState("");
  const { message, modalDirList } = useSelector((state) => state.master);
  const handleNameChange = (e) => {
    const inputValue = e.target.value;
    setName(inputValue);

    if (inputValue.trim() !== '') {
      setErrorMsg('');
    }
  };

  const handleModelChange = (selectedOption) => {
    setModelName(selectedOption);
    setModelError("");
  };

  const handleClose = () => {
    setShow(false);
    setModelName("");
    setName("");
    dispatch(resetMasterMessage()); // Clear message on close
  };

  const handleSubmitData = async () => {
    let valid = true;

    if (!modelName) {
      setModelError("Please select a model");
      valid = false;
    }

    if (name.trim() === "") {
      setErrorMsg("Please enter the model name");
      valid = false;
    }

    if (!valid) return;

    dispatch(loadingMasterAction(true)); // start loader

    try {
      await dispatch(modelAddAction({
        name: name.trim(),
        model: modelName.value
      }));

      // Clear form if successful
      setModelName(null);
      setName("");
      setErrorMsg("");
      setModelError("");

    } catch (error) {
      console.error("Model add failed:", error);
      // Optionally show an error toast here
    } finally {
      dispatch(loadingMasterAction(false)); // stop loader
    }
  };


  return (
    <>
      <button className="btn btn-primary btn-sm rounded-circle" style={{ padding: '6px' }} onClick={handleShow}>
        <Plus />
      </button>

      <Modal
        show={show}
        // onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Add Module </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div className="mb-3" style={{ position: "relative" }}>
            <label htmlFor="exampleFormControlInput2" className="form-label">
              Module
            </label>
            <Select
              placeholder="Select Module"
              options={modalDirList}
              value={modelName}
              onChange={handleModelChange}
              menuPosition="fixed"
              menuPortalTarget={document.body}
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor: modelError ? "red" : base.borderColor,
                  boxShadow: modelError ? "0 0 0 1px red" : base.boxShadow,
                }),
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999, // Ensure the dropdown is on top of the modal
                }),
              }}
            />

            {modelError && (
              <div className="text-danger" style={{ position: "absolute", bottom: -20 }}>
                {modelError}
              </div>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Name
            </label>
            <input
              type="text"
              className={`form-control ${errorMsg ? 'has-error border border-danger' : ''}`}
              name="name"
              id="exampleFormControlInput1"
              placeholder="Enter Name"
              value={name}
              onChange={handleNameChange}
            />
            {errorMsg && (
              <div className="text-danger" style={{ position: 'absolute' }}>
                {errorMsg}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 d-flex justify-content-between gap-1">
            <div>
              {message && (
                <>
                  {message.status === 200 ? (
                    <h6 className="text-success">Model Added Successfully...</h6>
                  ) : ((message.status === 500 && message.message.includes('Cannot read')) || message.status === 400) ? (
                    <h6 className="text-danger">Model already exists.</h6>
                  ) : (
                    <h6 className="text-warning">{message.message}</h6>
                  )}
                </>
              )}
            </div>
            <div>
              <Button
                variant="secondary"
                className="mr-1"
                onClick={handleClose}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="ml-1"
                onClick={handleSubmitData}
              >
                Submit
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalAdd;
